import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { formatDateTime } from '@juvare/common-web-ui/utils';
import { Typography } from '@mui/material';
import { parseISO } from 'date-fns';
import React from 'react';
import { AlertNotificationContentHeader } from '../../../../../components/AlertNotificationContentHeader';
import { useAlertUiTranslation } from '../../../../../hooks';
import { AlertActionsArchived } from './AlertActionsArchived';
import { AlertActionsDraft } from './AlertActionsDraft';
import { AlertActionsSent } from './AlertActionsSent';
import { AlertActionsTemplate } from './AlertActionsTemplate';
export const AlertHeader = ({ data, onReload, onCloseDialog, }) => {
    var _a, _b, _c, _d;
    const { t } = useAlertUiTranslation();
    const statusLikeSent = ['sent', 'sending', 'failed', 'archived'].includes((_a = data === null || data === void 0 ? void 0 : data.status) !== null && _a !== void 0 ? _a : '');
    let dateTimeText = '';
    if (data) {
        if (['sent', 'sending', 'failed'].includes((_b = data.status) !== null && _b !== void 0 ? _b : '')) {
            if (data.terminatedAt) {
                dateTimeText = t('common.canceledDate', { date: formatDateTime(parseISO(data.terminatedAt)) });
            }
            else {
                dateTimeText = t('common.sentDate', { date: formatDateTime(parseISO((_c = data.sendDateTime) !== null && _c !== void 0 ? _c : data.updated)) });
            }
        }
        else if (data.status === 'archived') {
            dateTimeText = t('common.archivedDate', { date: formatDateTime(parseISO(data.updated)) });
        }
        else {
            dateTimeText = t('common.lastUpdateDate', { date: formatDateTime(parseISO(data.updated)) });
        }
    }
    const user = statusLikeSent ? data === null || data === void 0 ? void 0 : data.sentBy : data === null || data === void 0 ? void 0 : data.updatedBy;
    const title = statusLikeSent || (data === null || data === void 0 ? void 0 : data.status) === 'draft' ? data === null || data === void 0 ? void 0 : data.subject : data === null || data === void 0 ? void 0 : data.title;
    let sharedOrNot = '';
    if ((data === null || data === void 0 ? void 0 : data.status) === 'template') {
        // TODO check this logic after permission are properly implemented, related ticket ALS-1484
        if (((_d = data.permissions) === null || _d === void 0 ? void 0 : _d.find((permission) => permission.type !== 'user')) != null) {
            sharedOrNot = t('common.shared');
        }
        else {
            sharedOrNot = t('common.notShared');
        }
    }
    let phinBadge = '';
    if (data === null || data === void 0 ? void 0 : data.phin) {
        if (data.phin.communicationSensitive) {
            phinBadge = t('phin.common.phinSensitive');
        }
        else {
            phinBadge = t('phin.common.phinNotSensitive');
        }
    }
    const AlertActionsComponent = () => {
        if ((data === null || data === void 0 ? void 0 : data.status) === 'archived') {
            return React.createElement(AlertActionsArchived, { data: data, onReload: onReload, onCloseDialog: onCloseDialog });
        }
        if ((data === null || data === void 0 ? void 0 : data.status) === 'draft') {
            return React.createElement(AlertActionsDraft, { data: data, onReload: onReload, onCloseDialog: onCloseDialog });
        }
        if ((data === null || data === void 0 ? void 0 : data.status) === 'sent' || (data === null || data === void 0 ? void 0 : data.status) === 'sending' || (data === null || data === void 0 ? void 0 : data.status) === 'failed') {
            return React.createElement(AlertActionsSent, { data: data, onReload: onReload, onCloseDialog: onCloseDialog });
        }
        if ((data === null || data === void 0 ? void 0 : data.status) === 'template') {
            return React.createElement(AlertActionsTemplate, { data: data, onReload: onReload, onCloseDialog: onCloseDialog });
        }
        return undefined;
    };
    const Title = () => {
        return (React.createElement(React.Fragment, null,
            (data === null || data === void 0 ? void 0 : data.status) === 'draft' && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { component: 'span', variant: 'h6', color: themeColors.accent.red.bold }, t('common.draft')),
                ' - ')),
            title));
    };
    return (React.createElement(AlertNotificationContentHeader, { actionsComponent: React.createElement(AlertActionsComponent, null), dateTimeText: dateTimeText, phinBadgeLabel: phinBadge, title: React.createElement(Title, null), notificationMessageType: data === null || data === void 0 ? void 0 : data.messageType, sender: user, sharedOrNotText: sharedOrNot, icon: data === null || data === void 0 ? void 0 : data.icon, iconColor: data === null || data === void 0 ? void 0 : data.color }));
};
